import React from 'react';

export default class extends React.Component {
  static defaultProps = {
    colour: 'black',
    limit: { x: 1, y: 1 },
    ticksX: false,
    ticksY: true,
    mode: {
      x: 'auto',
      y: 'auto'
    },
    keys: {
      x: [],
      y: []
    }
  };

  getGraduation = (axis) => {
    // 0 if undefined or 1
    const l = this.props.limit[axis] === undefined ? 0 : this.props.limit[axis];
    const mode = this.props.mode[axis];
    if (mode === 'key') {
      const keys = this.props.keys[axis];
      if (keys.length > 1) {
        return l / (keys.length - 1);
      } else {
        return l;
      }
    }

    const r = l
      .toExponential()
      .split('e+')
      .map((v) => Math.ceil(parseFloat(v)));
    const res = r[0] * Math.pow(10, r[1] - 1);
    if (mode === 'integer') {
      return Math.ceil(res);
    } else {
      return res;
    }
  };

  render() {
    let i, py, text;
    let asc, end;
    const limit_x = this.props.limit.x === undefined ? 0 : this.props.limit.x;
    const limit_y = this.props.limit.y === undefined ? 0 : this.props.limit.y;

    if (Math.abs(limit_x) === Infinity || Math.abs(limit_y) === Infinity) {
      return (
        <div className="graph">
          <svg style={{ fill: 'none' }}>
            <line x1={-10} y1={0} x2={0} y2={0} stroke={this.props.colour} />
            <line x1={0} y1={0} x2={0} y2="100%" stroke={this.props.colour} />
            <line x1={-10} y1="100%" x2="100%" y2="100%" stroke={this.props.colour} />
          </svg>
          <svg>
            <line x1={0} y1={0} x2={0} y2={10} stroke={this.props.colour} />
            <line x1="100%" y1={0} x2="100%" y2={10} stroke={this.props.colour} />
          </svg>
        </div>
      );
    }

    const gx = this.getGraduation('x');
    const gy = this.getGraduation('y');

    const px = 100 / (limit_x / gx);

    const x = [];

    for (
      i = 0, end = Math.floor(limit_x / gx), asc = 0 <= end;
      asc ? i <= end : i >= end;
      asc ? i++ : i--
    ) {
      if (this.props.ticksX || i === 0 || i === Math.floor(limit_x / gx)) {
        text = this.props.mode.x === 'key' ? this.props.keys.x[i] : gx * i;
        x.push(
          <line
            key={`l${i}`}
            x1={`${i * px}%`}
            y1={0}
            x2={`${i * px}%`}
            y2={10}
            stroke={this.props.colour}
          />
        );
        x.push(
          <text key={`t${i}`} x={`${i * px}%`} y={25} fill={this.props.colour} textAnchor="middle">
            {text}
          </text>
        );
      }
    }

    const y = [];

    if (this.props.maxMinY) {
      let asc1, end1;
      const min = (this.props.min != null ? this.props.min.y : undefined) || 0;
      const max = Math.floor(
        (this.props.max != null ? this.props.max.y : undefined) || limit_y / gy
      );
      py = 100 / ((max - min) / gy);
      for (
        i = min, end1 = max, asc1 = min <= end1;
        asc1 ? i <= end1 : i >= end1;
        asc1 ? i++ : i--
      ) {
        text = this.props.mode.y === 'key' ? this.props.keys.y[i] : gy * i;
        const yp = 100 - (i - min) * py;
        y.push(
          <line
            key={`l${i}`}
            x1={0}
            y1={`${yp}%`}
            x2={-10}
            y2={`${yp}%`}
            stroke={this.props.colour}
          />
        );
        y.push(
          <text key={`t${i}`} x={-15} y={`${yp}%`} fill={this.props.colour} textAnchor="end">
            {text}
          </text>
        );
      }
    } else {
      let asc2, end2;
      py = 100 / (limit_y / gy);
      for (
        i = 0, end2 = Math.floor(limit_y / gy), asc2 = 0 <= end2;
        asc2 ? i <= end2 : i >= end2;
        asc2 ? i++ : i--
      ) {
        if (this.props.ticksY || i === 0 || i === Math.floor(limit_y / gy)) {
          text = this.props.mode.y === 'key' ? this.props.keys.y[i] : gy * i;
          y.push(
            <line
              key={`l${i}`}
              x1={0}
              y1={`${100 - i * py}%`}
              x2={-10}
              y2={`${100 - i * py}%`}
              stroke={this.props.colour}
            />
          );
          y.push(
            <text
              key={`t${i}`}
              x={-15}
              y={`${100 - i * py}%`}
              fill={this.props.colour}
              textAnchor="end"
            >
              {text}
            </text>
          );
        }
      }
    }

    return (
      <div className="graph">
        <svg style={{ fill: 'none' }}>
          <line x1={0} y1={0} x2={0} y2="100%" stroke={this.props.colour} />
          <line x1={-10} y1="100%" x2="100%" y2="100%" stroke={this.props.colour} />
          {y}
          {this.props.children}
          <text textAnchor="end" x="98%" y="98%" fill={this.props.colour} />
        </svg>
        <svg>{x}</svg>
      </div>
    );
  }
}
